import script from "./ListFilesInvestors.vue?vue&type=script&setup=true&lang=js"
export * from "./ListFilesInvestors.vue?vue&type=script&setup=true&lang=js"

import "./ListFilesInvestors.vue?vue&type=style&index=0&id=afe5d5c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe5d5c4"]])

export default __exports__